import { Fragment, useRef, useCallback, useMemo } from "react";
import useKeyboardShortcut from "shared/hooks/keyboard/useKeyboardShortcut";
import "./TwistKeyboardMoveCommander.css";
import keyboardLayout from "shared/assets/images/keyboards/keyboard-twist-layout2.png";
const TwistKeyboardMoveCommander = (props) => {
  const {
    OnCommandCreated: onCommandCreated,
    EnableKeyboard: enableKeyboard,
    ThrottleInterval: throttleInterval,
  } = props;

  const twistDataRef = useRef({
    x: 0,
    y: 0,
    z: 0,
    th: 0,
    speed: 0.5,
    turn: 1.0,
  });

  // Constants - moved to useMemo for better performance
  const constants = useMemo(
    () => ({
      SPEED_LIMIT: 1000,
      TURN_LIMIT: 1000,
      MIN_SPEED: 0.1,
      MIN_TURN: 0.1,
    }),
    []
  );

  // Move bindings - memoized for performance
  const moveBindings = useMemo(
    () => ({
      w: [1, 0, 0, 0],
      e: [1, 0, 0, -1],
      a: [0, 0, 0, 1],
      d: [0, 0, 0, -1],
      q: [1, 0, 0, 1],
      s: [-1, 0, 0, 0],
      c: [-1, 0, 0, 1],
      z: [-1, 0, 0, -1],
      W: [1, 0, 0, 0],
      E: [1, -1, 0, 0],
      A: [0, 1, 0, 0],
      D: [0, -1, 0, 0],
      Q: [1, 1, 0, 0],
      S: [-1, 0, 0, 0],
      C: [-1, -1, 0, 0],
      Z: [-1, 1, 0, 0],
      t: [0, 0, 1, 0],
      b: [0, 0, -1, 0],
    }),
    []
  );

  const speedBindings = useMemo(
    () => ({
      u: [1.1, 1.1],
      m: [0.9, 0.9],
      i: [1.1, 1],
      ",": [0.9, 1],
      o: [1, 1.1],
      ".": [1, 0.9],
    }),
    []
  );

  const controlKeys = useMemo(
    () => [...Object.keys(moveBindings), ...Object.keys(speedBindings)],
    [moveBindings, speedBindings]
  );

  const handleMove = useCallback(
    (twist) => {
      if (onCommandCreated) {
        onCommandCreated(twist, true);
      }
    },
    [onCommandCreated]
  );

  // Handle keyboard input using useKeyboardShortcut hook
  const handleKeyboardInput = useCallback(
    (event, { key, pressedKeys }) => {
      console.log("Key pressed:", key, "All pressed keys:", pressedKeys);

      // Handle speed bindings immediately
      if (key in speedBindings) {
        const [speedMultiplier, turnMultiplier] = speedBindings[key];
        const prev = twistDataRef.current;

        const newSpeed = Math.max(
          constants.MIN_SPEED,
          Math.min(constants.SPEED_LIMIT, prev.speed * speedMultiplier)
        );

        const newTurn = Math.max(
          constants.MIN_TURN,
          Math.min(constants.TURN_LIMIT, prev.turn * turnMultiplier)
        );

        console.log("Speed updated:", { speed: newSpeed, turn: newTurn });
        const newTwistData = { ...prev, speed: newSpeed, turn: newTurn };
        twistDataRef.current = newTwistData;
      }

      // Handle movement bindings - find the last pressed movement key
      const movementKeys = pressedKeys.filter((k) => k in moveBindings);

      if (movementKeys.length > 0) {
        // Use the most recently pressed movement key
        const lastMovementKey = movementKeys[movementKeys.length - 1];
        const [x, y, z, th] = moveBindings[lastMovementKey];

        const prev = twistDataRef.current;
        twistDataRef.current = {
          ...prev,
          x,
          y,
          z,
          th,
        };
      } else {
        // No movement keys pressed, stop movement
        const prev = twistDataRef.current;
        twistDataRef.current = {
          ...prev,
          x: 0,
          y: 0,
          z: 0,
          th: 0,
        };
      }
      // Call the command handler with the updated twist data
      if (onCommandCreated) {
        const twistData = twistDataRef.current;
        const twist = {
          linear: {
            x: twistData.x * twistData.speed,
            y: twistData.y * twistData.speed,
            z: twistData.z * twistData.speed,
          },
          angular: {
            x: 0,
            y: 0,
            z: twistData.th * twistData.turn,
          },
        };

        handleMove(twist);
      }
    },
    [moveBindings, speedBindings, constants, onCommandCreated, handleMove]
  );

  // Use the keyboard shortcut hook
  const { pressedKeys, pressedKeyCodes } = useKeyboardShortcut(
    enableKeyboard ? handleKeyboardInput : null,
    controlKeys,
    null,
    {
      enableKeyPress: enableKeyboard,
      trackPressedKeys: true,
      preventDefault: true,
      enableRepeat: true,
      throttleInterval: throttleInterval || 80,
    }
  );

  return (
    <Fragment>
      <div className="robot-control" tabIndex={0}>
        <img
          src={keyboardLayout}
          alt="Keyboard Layout"
          className="keyboard-layout-img"
          style={{
            width: "100%",
            maxWidth: 600,
            display: "block",
            margin: "0 auto",
          }}
        />
        {/* <h4>Keyboard Control</h4>
        <div>Moving around keys: q w e a s d z c</div>
        <div>t: up (+z) | b: down (-z)</div>
        <div>u/m: increase/decrease max speeds by 10%</div>
        <div>i/,: increase/decrease only linear speed by 10%</div>
        <div>o/.: increase/decrease only angular speed by 10%</div>
        <div style={{ marginTop: "10px", fontSize: "0.9em", color: "#666" }}>
          {twistDataRef.current.turn.toFixed(2)}
        </div>
        <div style={{ marginTop: "5px", fontSize: "0.8em", color: "#999" }}>
          Pressed keys: {pressedKeyCodes.join(", ") || "None"}
        </div> */}
      </div>
    </Fragment>
  );
};

export default TwistKeyboardMoveCommander;
